import type { ExtractPropTypes, PropType } from 'vue'
import { buttonsProps } from '@el-plus/components/buttons'
import type { AttachmentProps } from '@el-plus/components/attachment'
import type { PageMode } from '@el-plus/hooks/use-navigation'
export type defaultButtonsProps =
  | 'edit'
  | 'save'
  | 'cancel'
  | 'refresh'
  | 'auditLog'

export const headerProps = {
  // 页面模式
  mode: {
    type: String as PropType<PageMode>,
  },
  allowBack: {
    type: Boolean,
    default: true,
  },
  buttons: {
    ...buttonsProps.list,
  },
  name: String, // 权限前缀
  // 要展示的默认按钮
  defaultButtons: {
    type: Array as PropType<defaultButtonsProps[]>,
  },
  // 工作流id
  workflowId: String,
  // 是否显示附件按钮
  isShowAttachmentButton: {
    type: Boolean,
    default: false,
  },
  // 附件列表
  fileList: {
    type: Array as PropType<Record<string, any>[]>,
    default: () => [],
  },
  attachmentProps: {
    type: Object as PropType<AttachmentProps>,
    default: () => {},
  },
} as const
export type HeaderProps = ExtractPropTypes<typeof headerProps>

export const headerEmits = {}
export type HeaderEmits = typeof headerEmits
